// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

export default {
  'OK': {'es': 'Ok'},
  'Yes': {'es': 'Si'},
  'No': {'es': 'No'},
  'Version': {'es': 'Versión'},
  'Video': {'es': 'Vídeo'},
  'Adherence System': {'es': 'Sistema de adherencia'},
  'Sign-in': {'es': 'Iniciar sesión'},
  'Email Address': {'es': 'Correo electrónico'},
  'Enter email': {'es': 'Introducir correo electrónico'},
  'Password': {'es': 'Contraseña'},
  'Help on email': {'es': 'Ayuda por correo electrónico'},
  'Forgot Password': {'es': '¿Has olvidado tu contraseña?'},
  'Login': {'es': 'Login'},
  'Reset Password': {'es': 'Reiniciar contraseña'},
  'Please enter your Email address and we will send you a link via email to reset your password.': {'es': 'Por favor, introduzca su correo electrónico y le enviaremos un enlace para poder reiniciar su contraseña'},
  'Submit': {'es': 'Enviar'},
  'Reset Password request': {'es': 'Se requiere reiniciar contraseña'},
  'Type in your new password': {'es': 'Escriba tu nueva contraseña'},
  'Change Password': {'es': 'Cambiar la contraseña'},
  'Update': {'es': 'Actualización'},
  'Cancel': {'es': 'Cancelar'},
  'Current password': {'es': 'Contraseña actual'},
  'New password': {'es': 'Nueva contraseña'},
  'Confirm your password': {'es': 'Confirma tu contraseña'},
  'Expired password request link': {'es': 'Enlace de solicitud de contraseña caducado'},
  'Request reset password link': {'es': 'solicitar enlace para reiniciar contraseña'},
  'Search patients': {'es': 'Buscar pacientes'},
  'Patient Name': {'es': 'Nombre del paciente'},
  'Description': {'es': 'Descripción'},
  'View Patients': {'es': 'Ver pacientes'},
  'Add Patient': {'es': 'Añadir paciente'},
  'Logout': {'es': 'Cerrar sesión'},
  'Are you sure you want to logout?': {'es': '¿Está seguro de querer Cerrar Sesión?'},
  'Remove': {'es': 'Eliminar'},
  'Remove Patient': {'es': 'Eliminar paciente'},
  'Notification': {'es': 'Notificaciones'},
  'On': {'es': 'encendidas'},
  'Off': {'es': 'apagadas'},
  'Per page': {'es': 'Por página'},
  'Patient Reference': {'es': 'Nombre del paciente'},
  'Start at': {'es': 'Empieza el'},
  'Are you sure you would like to remove this patient?': {'es': '¿Está seguro de querer eliminar este paciente?'},
  'Are you sure you would like to remove this schedule?': {'es': '¿Está seguro de querer eliminar este planificación?'},
  'Are you sure you would like to remove this recipient?': {'es': '¿Está seguro de querer eliminar este contactos?'},
  'Are you sure you would like to erase this Dose.': {'es': '¿Está seguro de querer eliminar este dosis?'},
  'Are you sure you want to save all changes to this patient?': {'es': '¿Está seguro que desea guardar todos los cambios de este paciene?'},
  'taken': {'es': 'tomada'},
  'Blister': {'es': 'dosis'},
  'Sort by': {'es': 'Ordenar por'},
  'Please select one': {'es': 'Por favor, seleccione uno'},
  'Start Date': {'es': 'Fecha de inicio'},
  'Start Date:': {'es': 'Fecha de inicio:'},
  'Descending Start Date': {'es': 'Fecha de inicio descendente'},
  'Select Date': {'es': 'Seleccionar fecha'},
  'Short description to identify this schedule': {'es': 'Breve descripción para identificar esta planificación'},
  'NFC Code': {'es': 'Código NFC'},
  'Scan the NFC tag using your mobile device and enter the code': {'es': 'Escanea la etiqueta NFC usando tu dispositivo móvil e introduce el código'},
  'Mevia Code': {'es': 'Código Mevia'}, 
  'Enter the code found on the back of the MEVIA device': {'es': 'Introduzca el código que se encuentra en la parte posterior del dispositivo MEVIA'},
  'Device': {'es': 'Dispositivo'},
  'Rating': {'es': 'Valoración de adherencia'},
  'Card ID': {'es': 'Etiqueta ID'},
  'Add Dose': {'es': 'Añadir dosis'},
  'Change Video': {'es': 'Añadir Video'},
  'Assign Card': {'es': 'Asignar dispositivo'},
  'Clone': {'es': 'Clonar'},
  'Info for device': {'es': 'Información sobre el dispositivo'},
  'Battery Status': {'es': 'Estado de la batería'},
  'Signal Strength': {'es': 'Fuerza de la señal'},
  'Youtube Code': {'es': 'Código de YouTube'},
  'ex: for url https://www.youtube.com/watch?v=ri74QCJW1rQ the video code is ri74QCJW1rQ': {'es': 'Ejemplo: para la url https://www.youtube.com/watch?v=ri74QCJW1rQ el código del video es ri74QCJW1rQ'},
  'Invalid youtube video code': {'es': 'Código de video de YouTube inválido '},
  'Save': {'es': 'Guardar'},
  'Patient Reference:': {'es':  'Nombre del paciente:'},
  'this field is required': {'es': 'Campo obligatorio'},
  'invalid start date': {'es': 'Fecha de inicio invalida'},
  'Email:': {'es': 'Correo electrónico:'},
  'Phone:': {'es': 'Teléfono:'},
  'Country code': {'es': 'Código del país'},
  'Phone number': {'es': 'Número de teléfono'},
  'Timezone:': {'es': 'Zona horaria:'},
  'Timezone': {'es': 'Zona horaria'},
  'invalid timezone': {'es': 'Zona horaria invalida'},
  'Default Notification Message': {'es': 'Mensaje de notificación por defecto'},
  'Reminder Notification': {'es': 'Notificación recordatorio'},
  'Missing Notification': {'es': 'Notificación de olvido'},
  'Monitoring Only': {'es': 'Solo seguimiento'},
  'Report Date Range Selection': {'es': 'Selección del intervalo de fechas del informe'},
  'Report Start Date': {'es': 'Fecha de inicio del informe'},
  'Select Start Date': {'es': 'Seleccione la fecha de inicio'},
  'Report End Date': {'es': 'Fecha final del informe'},
  'Select End Date': {'es': 'Seleccione la fecha final'},
  'Select Schedule Date Range': {'es': 'Seleccione el rango de fechas de la planificación'},
  'End Date': {'es': 'Fecha de finalización'},
  'Schedule doses': {'es': 'Programar dosis'},
  'None': {'es': 'Ninguno'},
  'Label': {'es': 'Título'},
  'Dose intake': {'es': 'Toma de dosis'},
  'Intake date': {'es': 'Fecha de la toma'},
  'Intake time': {'es': 'Hora de la toma'},
  'Overall Adherence': {'es': 'Adherencia general'},
  'Report': {'es': 'Informe'}, 
  'Settings': {'es': 'Ajustes'},
  'New Schedule': {'es': 'Nueva planificación'},
  'Dose Scheduler': {'es': 'Programador de dosis'},
  'Repeated': {'es': 'Repetidas'},
  'Schedule daily doses': {'es': 'Programar dosis diarias'},
  'Starting': {'es': 'Inicio'},
  'Until': {'es': 'Hasta'},
  'Single Dose': {'es': 'Única dosis'},
  'Date to Schedule dose': {'es': 'Fecha para programar la dosis'},
  'Schedule a dose for:': {'es': 'Programar hora'},
  'Weekly Schedule': {'es': 'Planificación semanal'},
  'Code': {'es': 'Código'},
  'Offset': {'es': 'Intérvalo respecto a la hora programada (min)'},
  'Message': {'es': 'Mensaje'},
  'Weekly Report': {'es': 'Informe Semanal'},
  'Tap here to see more. You\'re doing great Keep it up!': {'es': 'Toque aquí para ver más. Lo está haciendo muy bien ¡Siga así!'},
  'Tap here to find out. You\'re doing good Almost there!': {'es': 'Toque aquí para averiguarlo. Lo está haciendo bien ¡Estamos cerca!'},
  'Tap here to learn how to improve': {'es': 'Toque aquí para averiguar cómo mejorar'},
  'Report expires in': {'es': 'El informe vence en'},
  'hours': {'es': 'Horas'},
  'Your Schedule for': {'es': 'Su planificación para'},
  'Instructions:': {'es': 'Instrucciones'},
  'Your weekly report is here! Keep up the good work': {'es': '¡Su informe semanal está aquí! Siga con el buen trabajo'},
  'Your weekly report is here! Tap here to find out more.': {'es': '¡Su informe semanal está aquí! Toque aquí para obtener más información.'},
  'Active Doses': {'es': 'Dosis activas'},
  'Dose': {'es': 'Dosis'},
  'Tap to confirm dose': {'es': 'Toque para confirmar la dosis'},
  'Missed Doses': {'es': 'Dosis olvidadas'},
  'Tap to confirm late intake': {'es': 'Toque para confirmar una toma atrasada'},
  'Upcoming Doses': {'es': 'Próximas dosis'},
  'Scheduled for': {'es': 'Planificado para'},
  'You have no scheduled doses left for today': {'es': 'No le quedan dosis programadas para hoy'},
  'Intake Dose Comfirmation': {'es': 'Confirmación de la toma'},
  'Confirm': {'es': 'Confirmar'},
  'Please take your dose': {'es': 'Por favor, tome su dosis'},
  'Email': {'es': 'Correo electrónico'},
  'Phone': {'es': 'Teléfono'},
  'Add': {'es': 'Añadir '},
  'Name': {'es': 'Nombre'},
  'minutes to schedule time:': {'es': 'minutos para el tiempo programado'},
  'Notify': {'es': 'Notifique a'},
  'Sms': {'es': 'Sms'},
  'Manage recipients': {'es': 'Gestionar contactos'},
  'Edit': {'es': 'Editar'},
  'Add Reminder': {'es': 'Añadir recordatorio'},
  'Edit Reminder': {'es': 'Editar recordatorio'},
  'Manage Recipient': {'es': 'Gestionar contactos'},
  'Edit Recipient': {'es': 'Editar destinatario'},
  'Add Recipient': {'es': 'Añadir destinatario'},
  'Communication': {'es': 'Comunicación'},
  'Email address': {'es': 'Correo electrónico'},
  'invalid phone number': {'es': 'Número de teléfono invalido'},
  'invalid email': {'es': 'Email invalido'},
  'Patient Settings': {'es': 'Ajustes del paciente'},
  'Patient Language:': {'es': 'Idioma del paciente:'},
  'Close': {'es': 'Cerrar'},
  'General': {'es': 'General'},
  'Contact Information': {'es': 'Información de contacto'},
  'Example': {'es': 'Ejemplo'},
  'Via': {'es': 'A través de'},
  'Dose Event Editor': {'es': 'Editor de eventos de dosis'},	
  'YouTube Video Code Editor': {'es': 'Editor del código de video YouTube'},	
  'English': {'es': 'Inglés'},
  'Español': {'en': 'Spanish'},
  'Would you also like to switch reminder to ': {'es': '¿También te gustaría cambiar el recordatorio a'},
}
